import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { generateQueryParams } from "helpers/queryParams";
import { Link } from "react-router-dom";
import convertDateFormat from "Components/Date/DateFormat";
import DeleteModal from "Components/Modals/DeleteModal";
import { deleteBookingQuestion, getBookingQuestions } from "helpers/API Calls/System & Settings/Booking Questions";

const head = [
  { id: 0, name: "#", isSortable: true, key: "id" },
  { id: 1, name: "Question", isSortable: true, key: "title" },
  { id: 2, name: "Applies To", isSortable: true, key: "is_for_admin" },
  { id: 3, name: "Type", isSortable: true, key: "question_type_name" },
  { id: 4, name: "Required", isSortable: true, key: "is_required" },
  { id: 5, name: "Order", isSortable: true, key: "sequence" },
  { id: 14, name: "Status", isSortable: true, key: "status" },
  {id: 85, name: "Created", isSortable: true, key: "created_at"},
  {id: 96,name: "Updated", isSortable: true, key: "updated_at"},
  { id: 6, name: "Actions", isSortable: false, key: "actions" }
];

function BookingQuestion() {  
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});
  
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    
    const { filters, updateFilter } = useTableFilters();
  
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getBookingQuestions(generateQueryParams(filters));
      if (response.success) {
        setData(response.data.items);
        setPagination(response.data.pagination);
      }
      setIsLoading(false);
    }
  
    useEffect(() => {
      fetchData();
    }, [filters]);
  
    const handleDeleteClick = (item) => {
      setSelectedItem(item);
      setDeleteModal(true);
    };
  
    const handleDeleteConfirm = async () => {
      if (selectedItem) {
        const response = await deleteBookingQuestion(selectedItem.id);
        if (response.success) {
          setDeleteModal(false);
          setSelectedItem(null);
          fetchData();
        }
      }
    };
  
    const onCloseClick = () => {
      setDeleteModal(false);
      setSelectedItem(null);
    };
  
  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Booking Questions" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              isAddButton={true}
              buttonText="Add New Question"
              to="/booking-questions/create"
              updateFilter={updateFilter}
              filters={filters}
              > 
              {data.length > 0 && data.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td className="text-truncate">{item.title}</td>
                  <td>{item?.is_for_admin ? 'For Admin' : 'All Orders'}</td>
                  <td>{item?.question_type?.question_type}</td>
                  <td>{item?.is_required ? 'Yes' : 'No'}</td>
                  <td>{item?.sequence}</td>
                  <td>
                    <span className={`badge badge-soft-${item.status === 'active' ? 'success' : 'danger'}`}>
                      {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                    </span>
                  </td>
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.updated_at)}</td>
                  <td>
                    <div>
                      <Link to={`${item.id}/edit`} className="btn btn-primary btn-sm mx-1"><i className="bx bx-pencil"/></Link>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>
        }
      </Container>
    </div>
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`"${selectedItem?.title}" question`}
    />}
    </>
  );
}

export default BookingQuestion;
